import createSvgIcon from '@material-ui/core/utils/createSvgIcon';

const Template = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path d="M2 7.94118H3.52941V4.41176H0V7.94118ZM0 12.3529H3.52941V8.82353H0V12.3529ZM0 3.52941H3.52941V0H0V3.52941ZM4.41176 7.94118H15V4.41176H4.41176V7.94118ZM4.41176 12.3529H15V8.82353H4.41176V12.3529ZM4.41176 0V3.52941H15V0H4.41176Z" />
  </svg>,
  'Template'
);

export default Template;
